<template>
  <button class="editing-toggle icon" :class="{editing}" @click="toggleEditingMode">
    <v-icon name="edit"/>
  </button>
</template>
<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'editing-toggle',
    computed: {
      ...mapState(['editing'])
    },
    methods: {
      ...mapActions(['toggleEditingMode'])
    },
  }
</script>
<style scoped lang="sass">
  .editing-toggle
    min-width: unset
    transition: $transition-quick

    &.editing
      background-color: $blue
      color: $white
      border-color: transparent
</style>
